
(function($) {
    var $nav = $('[gr-nav]'),
        $navHeight = $nav.outerHeight(),
        navDropDown = '.nav-dropdown';

    $('[gr-search-trigger]').on('click', function() {
        window.groots.methods.toggleAttributeValue(this, 'gr-search-trigger', 'active', true);
        window.groots.methods.toggleAttributeValue(document.querySelector('[gr-search-panel]'), 'gr-search-panel', 'active', true);

        if (document.querySelector('.nav__main') !== null) {
            document.querySelector('.nav__main').classList.toggle('search-open');
        }

        $('#nav-input-search').focus();
    });

    $(document).on('click', function(e) {
        if ($(e.target).is(".nav-dropdown--search") || $(e.target).is(".nav-dropdown--search form input") ) {
            e.stopPropagation();
        } else {
            if (!$(e.target).closest('[gr-search-trigger]').length) {
                window.groots.methods.removeAttributeValue(document.querySelector('[gr-search-trigger]'), 'gr-search-trigger', 'active', true);
                window.groots.methods.removeAttributeValue(document.querySelector('[gr-search-panel]'), 'gr-search-panel', 'active', true);
                document.querySelector('.nav__main').classList.remove('search-open');
            }
        }
    });

    var initialScrollTop = $(window).scrollTop();

    $(window).on('scroll', window.groots.methods.debounce(function() {
        var currentScrollTop = $(window).scrollTop();
        var delta = currentScrollTop - initialScrollTop;

        if ($(window).scrollTop() > $navHeight && delta > 0 && !$nav.hasClass('is-hidden')) {
            $nav.addClass('is-hidden');
        } else if (delta < 0 && $nav.hasClass('is-hidden')) {
            $nav.removeClass('is-hidden');
        }

        initialScrollTop = currentScrollTop;
    }));

    $('.nav__link').on('click', function(e) {
        var $dropDown = $(this).next(navDropDown);

        if ($dropDown.length) {
            e.preventDefault();

            if ($(this).next(navDropDown).hasClass('is-active') ) {
                $(navDropDown).removeClass('is-active');
            } else {
                $(navDropDown).not($(this).next(navDropDown)).removeClass('is-active');
                $(this).next(navDropDown).toggleClass('is-active');
            }
        }
    });
})(jQuery);
